export type EngineLifecycle =
  | 'unloaded'
  | 'loading'
  | 'waiting-uciok'
  | 'waiting-readyok'
  | 'ready'
  | 'thinking'
  | 'stopping'
  | 'failed'
  | 'disabled';
export interface Search {
  fen: string;
  generation: number;
  requestId: string;
  movetime: number;
  skill?: number;
  hash?: number;
  newGame?: boolean;
}
export type EngineCommand =
  | { type: 'init'; generation: number; hash: number }
  | ({ type: 'analyze' | 'best-move' } & Search)
  | { type: 'stop' | 'dispose'; generation: number; requestId?: string };
export interface EngineInfo {
  depth: number;
  cp?: number;
  mate?: number;
  pv: string[];
  bound?: boolean;
}
export type EngineMessage =
  | { type: 'ready'; generation: number }
  | ({ type: 'info'; generation: number; requestId: string } & EngineInfo)
  | { type: 'best-move'; generation: number; requestId: string; move: string }
  | { type: 'stopped'; generation: number; requestId?: string }
  | { type: 'error'; generation: number; requestId?: string; message: string };
export interface EngineResult {
  generation: number;
  requestId: string;
  move: string;
  infos: EngineInfo[];
}
export const budgets = {
  classification: 700,
  refutation: 900,
  casual: 350,
  strong: 600,
  best: 800,
  startup: 5000,
};
